import { PureComponent } from 'react';
import { formatMarkdown } from 'helpers/i18n';
import CopyToClipboardNotificationIcon from '../../icons/CopyToClipboard.com.svg';

const translationHtml = formatMarkdown(__('notification.copyToClipboard'));

export default class CopyToClipboardNotification extends PureComponent {
  render() {
    return (
      <div className="notification-wrapper">
        <div className="notification-icon">
          <CopyToClipboardNotificationIcon width={26} height={32} />
        </div>
        <div className="notification-text">
          <span dangerouslySetInnerHTML={{ __html: translationHtml }} />
          <br />
          <span>{__('notification.copyToClipboard.additionalText')}</span>
        </div>
      </div>
    );
  }
}
